// 导入封装好的网络请求类工具
import Network from './network';

// 封装
// 接口请求
export const checkCode = (params) => Network.get('/checkCode', params);

export const fillIn = (params) => Network.get('/fillIn', params);

export const text = (params) => Network.get('/text', params);

export const buttonStatus = (params) => Network.get('/buttonStatus', params);

export const queryStatusByCardKey = (params) => Network.get('/queryStatusByCardKey', params);

